import Vue from "vue"
import { timeouts } from "@evercam/ui"

if (!Vue.__timeouts_mixin__) {
  // See https://nuxtjs.org/docs/directory-structure/plugins/#global-mixins
  Vue.__timeouts_mixin__ = true

  Vue.mixin(timeouts)
}
